
<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Confirmation !</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        {{word}}
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="activeModal.close(true)">Oui</button>
    <button type="button" class="btn btn-outline-danger" (click)="activeModal.close(false)">Non</button>
</div>
